import {
  Mapper,
  RemoveAlbumFnReq,
  RemoveAlbumFnRes,
  SharingResult,
  SharingResultDto,
} from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';

export class RemoveAlbumInteractor {
  private readonly RemoveAlbumFn = httpsCallable<RemoveAlbumFnReq, RemoveAlbumFnRes>(
    this.functions,
    'removeAlbum',
  );

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
    private readonly sharingResultMapper: Mapper<SharingResultDto, SharingResult>,
  ) {}

  public async execute(id: string, usersToRemoveFromService: string[]): Promise<SharingResult> {
    const res = await this.RemoveAlbumFn({
      auth: await this.getAuthDto.execute(),
      id,
      usersToRemoveFromService,
    });

    return this.sharingResultMapper.map(res.data.sharingResult);
  }
}
